import styled from 'styled-components';
import { H3 } from 'components/typography';
import { typography } from 'styles/settings';

export const Text = styled(H3)`
  ${typography.font.regular};
`;
